"use strict";import{IconDash200 as e}from"../src/elements/IconDash200.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-icon-dash200",e);
//# sourceMappingURL=sp-icon-dash200.js.map
